// @ts-check
/// <reference path="../types/index.js" />

import React, { createContext, useState } from 'react';

/** @type {FormUpdatedContextType} */
const defaultContextValue = {
  updatedForms: [],
  addFormCode: () => [],
  removeFormCode: () => [],
  resetFormCode: () => [],
};

/**
 * @type {React.Context<FormUpdatedContextType>}
 */
const FormUpdatedContext = createContext(defaultContextValue);

/**
 * Provides the context for tracking form updates
 * @param {{ children: React.ReactNode }} props
 * @return {JSX.Element}
 */
export const FormUpdatedProvider = ({ children }) => {
  /** @type {[string[], Function]} */
  const [updatedForms, setUpdatedForms] = useState([]);

  /**
   * Adds a form code to the list of updated forms if it's not already included
   * @param {string} code Form code to add
   */
  const addFormCode = (code) => {
    if (!code.length) {
      return;
    }

    setUpdatedForms((prev) => {
      /**
       * Adds a form code to the list of updated forms if it's not already included
       * @param {string} code Form code to add
       */
      if (!prev.includes(code)) {
        return [...prev, code];
      }
      return prev;
    });
  };

  /**
   * Removes a form code to from list of updated forms
   * @param {string} code Form code to add
   */
  const removeFormCode = (code) => {
    setUpdatedForms((prev) => {
      /**
       * Removes a form code from the list of updated forms if it's included
       * @param {string} code Form code to remove
       */
      return prev.filter((formCode) => formCode !== code);
    });
  };

  /**
   * Resets the updated forms array
   */
  const resetFormCode = () => {
    setUpdatedForms([]);
  };

  return (
    <FormUpdatedContext.Provider
      value={{ updatedForms, addFormCode, resetFormCode, removeFormCode }}
    >
      {children}
    </FormUpdatedContext.Provider>
  );
};

export default FormUpdatedContext;
